import { DateTimeHelper } from "src/app/utils/helpers/date-time.helper";
import { ExamEndingType } from "../enums";

export class TimeRestriction {
    day: string;
    startFromTime: string;
    startUntilTime: string;
    examEndingType: ExamEndingType = ExamEndingType.Duration;
    endTime: string;
    duration: number;

    constructor(startFromDate: string = '', startUntilDate: string = '', endDate: string = '', duration: number = 0) {
        this.day = startFromDate ? DateTimeHelper.getLocalDate(startFromDate) : '';
        this.startFromTime = startFromDate ? DateTimeHelper.getLocalTime(startFromDate) : '';
        this.startUntilTime = startUntilDate ? DateTimeHelper.getLocalTime(startUntilDate) : '';
        this.endTime = endDate ? DateTimeHelper.getLocalTime(endDate) : '';
        this.duration = duration;

        if (this.endTime) {
            this.examEndingType = ExamEndingType.EndDate;
        }

        if (this.duration) {
            this.examEndingType = ExamEndingType.Duration;
        }
    }
}


